import React, { Component, Fragment } from 'react';
import { Button, Grid, GridRow, GridColumn, Checkbox } from 'semantic-ui-react';
import ReactTable from 'react-table';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router';

import { actions } from './state/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import { createToast, toastType } from 'Common/ToastHelper';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { Filter, Main } from '../../containers/';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { tabEnum } from './helpers/SiteSetupConstants';
import { validateChargeLimits } from './helpers/SiteSetupHelpers';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { DirtyWrapper } from 'Components/';
import { EditModal } from './components/EditModal';
import { AssignItemsModal } from './components/AssignItemsModal';
import { isPreferenceDisabled } from 'Common/Security/SecurityHelpers';
import { PreferencesEnum } from 'Common/Security/PreferencesEnum';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import 'PageStyles/sitesetup/index.less';
import { AssignServedItemsToSiteModal } from '../serveditemaccesssetup/AssignServedItemsToSiteModal';
import { FieldEnum } from 'Common/FieldEnum';

class SiteSetupContainer extends Component {
  state = {
    modalData: {},
    showModal: false,
    isEditValid: true,
    showDeleteModal: false,
    showAssignModal: false,
    showAssignItemsModal: false,
    isNewSite: false,
    showYesNoDirty: false,
    YesNoDirtyResponse: null,
    fetching: false,
    filtered: [],
  };

  componentDidMount() {
    this.props.getSiteSetup({
      IsLicensed: this.props.showLicensed,
      IsActive: this.props.showActive,
    });
    this.props.getStorageLocations();
    this.props.getHandlingFeeList();
  }

  componentDidUpdate() {
    const { siteDetails, chargeLimit, enrollment, servedItems } = this.props;

    if (
      siteDetails.fetched &&
      chargeLimit.fetched &&
      enrollment.fetched &&
      servedItems.nutritionFetched
    ) {
      this.setState(
        {
          modalData: siteDetails.data,
          showModal: true,
          isEditValid: true,
          isNewSite: false,
          fetching: false,
        },
        () => {
          this.props.clearFetched();
        }
      );
    }
  }

  onEditClick = row => {
    this.setState({
      modalData: row,
      showModal: true,
      isEditValid: true,
      isNewSite: false,
      fetching: true,
    });

    this.props.getChargeByStatus(row.Id);
    this.props.getSiteDetails(row.Id);
    this.props.getEnrollmentDetails(row.Id);
    this.props.getServedItemsNutrition();
  };

  closeEditModalYes = () => {
    this.setState({ showModal: false });
    this.props.setSelectedTab(tabEnum.SITE_DETAILS);
    this.props.resetDirty();
  };

  handleEditSubmit = values => {
    const { chargeLimit } = this.props;

    //validate
    if (!validateChargeLimits(chargeLimit.restrictionType, chargeLimit.data)) {
      createToast(
        toastType.error,
        'Error',
        'You must enter at least one restriction.',
        true
      );
      this.props.setSelectedTab(tabEnum.CHARGE_LIMITS);

      return;
    }

    const thisSite = _.find(this.props.siteSetup.Data, { Id: values.Id });
    const updatedSite = _.omit({ ...thisSite, ...values }, 'SiteGroup');

    return this.props
      .postSitemaster(updatedSite)
      .then(result => {
        this.setState({ showModal: false });
        this.props.resetDirty();

        createToast(
          toastType.success,
          'Success',
          'The site has been saved',
          true
        );
        this.props.getSiteSetup({
          IsLicensed: this.props.showLicensed,
          IsActive: this.props.showActive,
        });
        this.props.setSelectedTab(tabEnum.SITE_DETAILS);
      })
      .catch(err => {
        createToast(toastType.error, err[0].Title, err[0].Message, true);
        this.setState({ isEditValid: false });
      });
  };

  //Add user
  onAddSiteClick = () => {
    this.setState({
      modalData: {
        Id: '',
        SiteGroupId: 99999,
      },
      showModal: true,
      isEditValid: false,
      isNewSite: true,
    });
    this.props.clearSiteDetails({
      Id: '',
      SiteGroupId: 99999,
    });
  };

  //Delete User
  onDeleteClick = row => {
    this.props.clearErrors();
    this.setState({ showDeleteModal: true, modalData: row });
  };

  onDeleteClose = () => {
    this.setState({ showDeleteModal: false });
    //needed because when errors are thrown from not
    //being able to delete we set inactive so now need to refresh
    this.props.getSiteSetup({
      IsLicensed: this.props.showLicensed,
      IsActive: this.props.showActive,
    });
  };

  handleDeleteSubmit = id => {
    this.setState({ showDeleteModal: false });

    return this.props
      .postDeleteSite(id)
      .then(result => {
        createToast(
          toastType.success,
          'Success',
          'The site has been deleted.',
          true
        );

        this.props.getSiteSetup({
          IsLicensed: this.props.showLicensed,
          IsActive: this.props.showActive,
        });
      })
      .catch(err => {
        createToast(toastType.error, 'Error', err[0].Message, true);
      });
  };

  onAssignUserClick = row => {
    const { showLicensed } = this.props;
    this.props.history.push(
      `/sitesetup/assignusers/${row.Id}/${showLicensed}/${row.Description}`
    );
  };

  onAssignItemClick = row => {
    this.setState({ showAssignItemsModal: true, modalData: row });
    this.props.getOrderingItemForCurrentSite(row);
  };

  closeAssignItemsModalYes = () => {
    this.setState({ showAssignItemsModal: false });
    // this.props.resetDirty();
    this.props.clearAssignItemsModal();
  };

  handleAssignItemsModal = () => {
    this.setState({ showAssignItemsModal: !this.state.showAssignItemsModal });
  };

  //Filter Change
  onFilterChange = (e, filter) => {
    let newValue = {
      IsLicensed: this.props.showLicensed,
      IsActive: this.props.showActive,
    };
    if (filter === FieldEnum.IsLicensed) {
      newValue.IsLicensed = !newValue.IsLicensed;
    } else {
      newValue.IsActive = !newValue.IsActive;
    }
    this.props.setShowLicensed(newValue.IsLicensed);
    this.props.setShowActive(newValue.IsActive);
    this.props.setFilteredData(newValue);
  };

  handleDialog(result) {
    if (result) {
      this.handleDeleteSubmit(this.state.modalData && this.state.modalData.Id);
    } else {
      this.setState({ showDeleteModal: false });
    }
  }

  menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: this.onEditClick,
    },
    {
      icon: 'trash',
      text: 'Delete Site',
      className: 'danger',
      handler: this.onDeleteClick,
      disabledWhen: x => {
        return (
          x.IsLicensed ||
          isPreferenceDisabled(
            PreferencesEnum.DeleteSite,
            this.props.security.preferences
          )
        );
      },
    },
    {
      icon: 'user outline',
      text: 'Assign User(s)',
      handler: this.onAssignUserClick,
      disabledWhen: x => !x.IsActive,
    },
    {
      icon: 'cart plus',
      text: 'Assign Items to Ordering Site',
      handler: this.onAssignItemClick,
      disabledWhen: x => x.SiteId !== x.PrimarySiteId,
    },
    {
      icon: 'food',
      text: 'Assign Served Items',
      handler: row =>
        this.setState({
          showAssignServedItemsToSiteModal: {
            siteId: row.Id,
            name: row.Description,
          },
        }),
      disabledWhen: row => {
        const disabledViaPreference = isPreferenceDisabled(
          PreferencesEnum.AssignServedItemsToSite,
          this.props.security.preferences
        );
        return (
          disabledViaPreference ||
          row.Id !== row.PrimarySiteId ||
          !row.IsActive ||
          !row.IsLicensed
        );
      },
    },
  ];

  render() {
    const {
      modalData,
      showModal,
      showAssignItemsModal,
      showAssignServedItemsToSiteModal,
    } = this.state;
    const { siteGroups, siteSetup, enrollment } = this.props;
    const { servedItems, isReadOnly } = this.props;
    const data = this.props.filteredData || [];

    return (
      <Fragment>
        <Filter title={'Site Setup'}>
          <Grid>
            <GridRow>
              <GridColumn width="5" floated="left" verticalAlign="middle">
                <Checkbox
                  label="Show Licensed"
                  toggle
                  checked={!this.props.showLicensed}
                  onChange={e => this.onFilterChange(e, FieldEnum.IsLicensed)}
                />
              </GridColumn>
              <GridColumn width="5" floated="left" verticalAlign="middle">
                <Checkbox
                  label="Show Active"
                  toggle
                  checked={!this.props.showActive}
                  onChange={e => this.onFilterChange(e, FieldEnum.IsActive)}
                />
              </GridColumn>
              <GridColumn width="6" floated="right" textAlign="right">
                <SecurityPreferences scope={PrefEnum.AddNewSite}>
                  {disabled => {
                    return (
                      <Button
                        content="Add Site"
                        onClick={this.onAddSiteClick}
                        disabled={disabled}
                      />
                    );
                  }}
                </SecurityPreferences>
              </GridColumn>
            </GridRow>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth>
          <Button
            className={'clear-filters-button'}
            content="Clear Filters"
            onClick={() => this.setState({ filtered: [] })}
          />
          <ReactTable
            minRows={0}
            loading={this.props.isGridLoading}
            data={data}
            resizable={false}
            className={'-striped -highlight grid--fixed-row-height'}
            defaultFilterMethod={caseInsensitiveFilter}
            filtered={this.state.filtered}
            onFilteredChange={filtered => this.setState({ filtered })}
            getTrProps={(state, rowInfo, column) => {
              return {
                style: {
                  color:
                    rowInfo &&
                    rowInfo.original &&
                    rowInfo.original.IsActive === true
                      ? ''
                      : 'red',
                },
              };
            }}
            columns={[
              {
                columns: [
                  {
                    Header: 'Id',
                    accessor: 'Id',
                    filterable: true,
                    resizable: true,
                  },
                  {
                    Header: 'Description',
                    accessor: 'Description',
                    filterable: true,
                    resizable: true,
                  },
                  {
                    Header: 'Site Group',
                    accessor: 'SiteGroupName',
                    filterable: true,
                    resizable: true,
                  },
                  {
                    Header: 'Site Type',
                    accessor: 'SiteType',
                    filterable: true,
                    resizable: true,
                  },
                  {
                    Header: 'Primary WH/K',
                    accessor: 'PrimarySiteWarehouse',
                    filterable: true,
                    resizable: true,
                  },
                  {
                    Header: 'MBE Date',
                    accessor: 'MealExpirationDT',
                    filterable: true,
                    resizable: true,
                  },
                  {
                    resizable: false,
                    width: 50,
                    sortable: false,
                    Cell: gridProps => {
                      return GridContextMenu({
                        gridProps,
                        options: this.menuOptions,
                      });
                    },
                  },
                ],
              },
            ]}
          />
        </Main>
        <DirtyWrapper
          closeModalYesCallback={this.closeEditModalYes}
          isReadOnly={isReadOnly}
        >
          {(showDirtyConfirm, showDirtyLinkConfirm) =>
            showModal && (
              <EditModal
                resetDirty={this.props.resetDirty}
                showEditModal={showModal}
                onClose={showDirtyConfirm}
                handleEditSubmit={this.handleEditSubmit}
                siteGroups={siteGroups}
                modalData={modalData}
                isEditValid={this.state.isEditValid}
                siteSetup={siteSetup}
                enrollmentData={enrollment.data}
                servedItems={servedItems.nutritionData}
                updateSiteDetails={obj => this.props.updateSiteDetails(obj)}
                showDirtyLinkConfirm={showDirtyLinkConfirm}
                isReadOnly={isReadOnly}
                isNewSite={this.state.isNewSite}
              />
            )
          }
        </DirtyWrapper>

        <YesNoDialog
          showDialog={this.state.showDeleteModal}
          title="Delete Site"
          question={` Are you sure you want to delete this site: ${
            modalData.Description
          }?`}
          yesCallback={() => {
            this.handleDialog(true);
          }}
          noCallback={() => {
            this.handleDialog(false);
          }}
        />

        <DirtyWrapper
          closeModalYesCallback={this.closeAssignItemsModalYes}
          isReadOnly={isReadOnly}
        >
          {showDirtyConfirm => (
            <AssignItemsModal
              showAssignItemsModal={showAssignItemsModal}
              modalData={modalData}
              handleAssignItemsModal={this.handleAssignItemsModal}
              onAssignItemsClose={showDirtyConfirm}
            />
          )}
        </DirtyWrapper>

        <DirtyWrapper
          closeModalYesCallback={() =>
            this.setState({ showAssignServedItemsToSiteModal: false })
          }
          // isReadOnly={isReadOnly}
        >
          {showDirtyConfirm =>
            showAssignServedItemsToSiteModal && (
              <AssignServedItemsToSiteModal
                onClose={showDirtyConfirm}
                // onSuccessClose={}
                {...showAssignServedItemsToSiteModal}
              />
            )
          }
        </DirtyWrapper>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    page,
    settings,
    chargeLimit,
    servedItems,
    assignUsers,
    enrollment,
    siteDetails,
    assignItems,
  } = state.SiteSetupState;

  return {
    enrollment,
    chargeLimit,
    servedItems,
    siteDetails,
    assignItems,
    siteSetup: page.siteSetup,
    filteredData: page.filteredData,
    siteGroups: page.siteGroups,
    showLicensed: settings.showLicensed,
    isGridLoading: settings.isGridLoading,
    assignUserData: assignUsers.data,
    isDirty: getIsDirty()(state),
    security: state.SecurityState,
    showActive: settings.showActive,
  };
};

export const SiteSetup = withRouter(
  connect(
    mapStateToProps,
    { ...actions, resetDirty }
  )(SiteSetupContainer)
);



// WEBPACK FOOTER //
// ./src/pages/sitesetup/SiteSetup.js